import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { aplicarTema } from './lib/tema';
import './estilo.css';

aplicarTema(); // antes de montar, para a tela não piscar branca
createRoot(document.getElementById('root')).render(<App />);
